import { environment } from '../../environments/environment';
import {
  KCC20_FIXED_DECIMALS,
  formatKcc20BaseUnitsForDisplay,
} from './kcc20-token-amount';

interface FeeTicketQuoteLike {
  executionMode?: string | null;
  fills?: unknown[] | null;
}

/** Fail-closed: coupon / FeeTicket UX and apply paths only when explicitly enabled. */
export function kcc20FeeTicketFeatureEnabled(): boolean {
  return environment.kcc20FeeTicketEnabled === true;
}

/** FeeTicket discount is stored in bps where 10_000 = 100%. */
export function feeTicketDiscountPercentLabel(
  discountBps: number | null | undefined,
): string {
  if (discountBps === null || discountBps === undefined) {
    return '--';
  }
  if (!Number.isFinite(discountBps)) {
    return '--';
  }
  const percent = discountBps / 100;
  const rounded = Number(percent.toFixed(4));
  return `${rounded}%`;
}

export function feeTicketUtilityTokenDisplayAmount(
  utilityTokenAmount: string | null | undefined,
  quantity: number,
  decimals = KCC20_FIXED_DECIMALS,
): string | undefined {
  const amount = utilityTokenAmount?.trim();
  if (!amount || !/^[1-9]\d*$/.test(amount)) {
    return undefined;
  }
  if (!Number.isInteger(quantity) || quantity <= 0) {
    return undefined;
  }
  return formatKcc20BaseUnitsForDisplay(
    BigInt(amount) * BigInt(quantity),
    decimals,
  );
}

export function feeTicketRequiredCountForExecution(
  quote: FeeTicketQuoteLike | null | undefined,
  activeFillOrderId: string | null | undefined,
): number {
  if (quote?.executionMode === 'multi' && Array.isArray(quote.fills)) {
    return quote.fills.length > 0 ? 1 : 0;
  }
  return activeFillOrderId ? 1 : 0;
}

export function feeTicketInsufficientReason(
  requiredTickets: number,
  availableTickets: number | null | undefined,
  options: { loading?: boolean } = {},
): string | undefined {
  if (requiredTickets <= 0) {
    return undefined;
  }
  if (options.loading) {
    return 'Loading coupon balance.';
  }
  if (availableTickets === null || availableTickets === undefined) {
    return 'Coupon balance is unavailable. Refresh or turn off the discount.';
  }
  if (availableTickets >= requiredTickets) {
    return undefined;
  }
  const ticketWord = requiredTickets === 1 ? 'coupon' : 'coupons';
  return `This discounted trade needs ${requiredTickets} ${ticketWord}; ${availableTickets} available.`;
}
